import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of, switchMap } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorDialogComponent } from "../../../shared/components/error-dialog/error-dialog.component";

import { AuthService } from "../services/auth.service";
import { authActions } from "./actions";
import { AuthDTO, AuthResponse } from "../auth.model";

export const authLoginEffect = createEffect(
  (actions$ = inject(Actions), authService = inject(AuthService)) => {
    return actions$.pipe(
      ofType(authActions.requestLogin),
      switchMap((data: AuthDTO) => {
        return authService.login(data.username).pipe(
          map((data: AuthResponse) => {
            if (data.success === true) {
              return authActions.requestLoginSuccess(data);
            } else {
              return authActions.requestLoginFailed(data);
            }
          }),
          catchError((error) => {
            return of(authActions.requestLoginFailed(error));
          })
        );
      })
    );
  },
  { functional: true }
);

export const authLoginFailedEffect = createEffect(
  (actions$ = inject(Actions), dialog = inject(MatDialog)) => {
    return actions$.pipe(
      ofType(authActions.requestLoginFailed),
      map(() => {
        dialog.open(ErrorDialogComponent, {
          data: {
            errorMessage: "Login attempt was unsuccessful. Please try again.",
          },
        });
      })
    );
  },
  { dispatch: false, functional: true }
);
